import { Route, Routes } from "react-router-dom";
import Layout from "../components/layout/Layout";
import NotFound from "../components/error/NotFound";
import Home from "../pages/home/index";
import AboutGermany from "../pages/about-germany";
import StudyProgram from "../pages/study-program";
import PartTime from "../pages/part-time";
import FinanceSupport from "../pages/finance-support";
import OpenBlockAccount from "../pages/open-block-account";
import ForexService from "../pages/forex-service";
import Accommodation from "../pages/accommodation";
import AccommodationMap from "../pages/accommodationMap";
import BookVisaAppointment from "../pages/book_visa_appointment";
import PrepareVisaFile from "../pages/prepare-visa-file";
import BlogDetailPage from "../pages/home/BlogDetailPage";
import ProgramDetailPage from "../pages/study-program/ProgramDetailPage";
import JobDetailPage from "../pages/part-time/JobDetailPage";
import CourseFinder from "../pages/courseFinder";
import OfferDetailsPage from "../pages/study-program/OfferDetailsPage";
import PrivacyPolicy from "../pages/privacy-policy";
import TermsCondition from "../pages/terms-condition";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termscondition" element={<TermsCondition />} />
        <Route path="/program/:id" element={<ProgramDetailPage />} />
        <Route path="/details/:id" element={<JobDetailPage />} />
        <Route path="/offer/:slug" element={<OfferDetailsPage />} />
        <Route path="/blog/:id" element={<BlogDetailPage />} />
        <Route path="/about" element={<AboutGermany />} />
        <Route path="/study-programs" element={<StudyProgram />} />
        <Route path="/course-finder" element={<CourseFinder />} />
        <Route path="/part-time-jobs" element={<PartTime />} />
        <Route path="/finance-support" element={<FinanceSupport />} />
        <Route path="/block-open-account" element={<OpenBlockAccount />} />
        <Route path="/forex-service" element={<ForexService />} />
        <Route path="/find-accommodation" element={<Accommodation />} />
        <Route path="/accommodation" element={<AccommodationMap />} />
        <Route
          path="/book-visa-appointment"
          element={<BookVisaAppointment />}
        />
        <Route path="/prepare-visa-file" element={<PrepareVisaFile />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default PublicRoutes;
